export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chevron.7072a86f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};